const _excluded = ["title", "titleId"];
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
import * as React from "react";
function SvgSantander(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "aa4c9726-c7ef-48e2-a8db-c5310e769947",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 52 52",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".eb365ad4-1653-44f6-ae4f-daf769975669{fill:#ef0000;}.b8dacb50-ae28-4690-b454-0131482e66b0{fill:#fff;}")), /*#__PURE__*/React.createElement("rect", {
    className: "eb365ad4-1653-44f6-ae4f-daf769975669",
    width: 52,
    height: 52,
    rx: 5
  }), /*#__PURE__*/React.createElement("path", {
    className: "b8dacb50-ae28-4690-b454-0131482e66b0",
    d: "M29.76,32a6,6,0,0,0,1.06-3,6.93,6.93,0,0,0-1-4.12c-1.26-2.17-2.5-4.35-3.77-6.52a7,7,0,0,1-1-4.36,6.49,6.49,0,0,1,1.07-3c.08.21.12.34.17.46a16.77,16.77,0,0,0,.76,1.73q2,3.47,4,6.9a9.57,9.57,0,0,1,1.75,4.56l.76.24a17.32,17.32,0,0,1,4.54,2,9.77,9.77,0,0,1,2.47,2.24,5.09,5.09,0,0,1,0,6.49,9.22,9.22,0,0,1-2.21,2.06A17.85,17.85,0,0,1,32.2,40.3a27.35,27.35,0,0,1-14.36-.55,15.79,15.79,0,0,1-4.37-2.12,8.87,8.87,0,0,1-2.28-2.25,5,5,0,0,1,0-5.92A8.3,8.3,0,0,1,13,27.55a16.34,16.34,0,0,1,5.85-2.77,2,2,0,0,1,.28,0,1.59,1.59,0,0,1,.06.3,7,7,0,0,0,1,3.6c1.42,2.46,2.85,4.92,4.25,7.4.51.89.94,1.82,1.4,2.74a5.81,5.81,0,0,0,.88-2.26,6.77,6.77,0,0,0-.83-4.76c-1.24-2.15-2.49-4.31-3.74-6.45a7.27,7.27,0,0,1-1.05-3.15,6.7,6.7,0,0,1,.93-4.06,2.58,2.58,0,0,1,.15-.25c.09.23.13.36.19.48a16.66,16.66,0,0,0,.77,1.72c1.77,3.12,3.57,6.22,5.36,9.32A9.81,9.81,0,0,1,29.76,32Z"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSantander);
export default __webpack_public_path__ + "static/media/SANTANDER.d6e8404a9526bdb5bfe40c7557ce7362.svg";
export { ForwardRef as ReactComponent };